import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, ArrowUpRight, Plus } from 'lucide-react';
import { VISUAL_EDITOR_ENABLED } from '../../config/featureFlags';

// OpenRequestsCard — Sprint D item 3.6. Combined open edit-request + ticket
// count with CTAs. count===0 still renders so the "Submit" CTA is reachable.

export default function OpenRequestsCard({ count = 0 }) {
  // Submit-new defaults to the visual editor when enabled, otherwise drops
  // the user on the Edits page so the click still has a destination.
  const submitTo = VISUAL_EDITOR_ENABLED ? '/portal/edits/visual' : '/portal/edits';
  return (
    <div data-testid="open-requests-card" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-gray-500 mb-2">
        <MessageCircle className="w-3 h-3" />
        Open requests
      </div>
      <div className="text-4xl font-bold text-white" data-testid="open-requests-count">{count}</div>
      <div className="mt-3 flex items-center gap-3">
        <Link
          to={submitTo}
          className="inline-flex items-center gap-1 text-[12px] text-[#B0FC38] hover:text-white"
        >
          <Plus className="w-3 h-3" /> Submit new
        </Link>
        <Link
          to="/portal/edits"
          className="inline-flex items-center gap-1 text-[12px] text-gray-300 hover:text-white"
        >
          View <ArrowUpRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  );
}
